import { useCallback, useEffect } from 'react';
import { USER_AREA_BASE_PATH } from '@pm2/api';
import { Link, TeamsIcon, CloseButton } from '@ui/kit';
import { safeLocalStorage } from '@utils/common';
import { useToggleState, SizeTransition } from '@utils/react';
import { Routes } from '../../../const.routes.js';
import { transitionWrapper, dismissDurationMs, wrapper, heading, body, inlineLink } from './atom.welcome-notice.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function WelcomeNotice(props) {
  return /*#__PURE__*/jsx(SizeTransition, {
    in: props.active,
    axis: "vertical",
    timeout: dismissDurationMs,
    mountOnEnter: true,
    unmountOnExit: true,
    classNames: transitionWrapper,
    children: ref => /*#__PURE__*/jsx("div", {
      ref: ref,
      className: transitionWrapper,
      children: /*#__PURE__*/jsxs("aside", {
        className: wrapper,
        children: [/*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("h1", {
            className: heading,
            children: "Besvarelser fra dine hold"
          }), /*#__PURE__*/jsxs("p", {
            className: body,
            children: ["Du har tidligere oprettet de hold, du \xF8nsker at modtage besvarelser fra.", /*#__PURE__*/jsx("br", {}), "Du kan nu se, tilf\xF8je nye og redigere dine hold under", " ", /*#__PURE__*/jsxs(Link, {
              href: `${USER_AREA_BASE_PATH}/${Routes.TEAMS}`,
              className: inlineLink,
              theme: "inline",
              children: [/*#__PURE__*/jsx(TeamsIcon, {
                height: "20"
              }), "Mine Hold"]
            })]
          })]
        }), /*#__PURE__*/jsx(Link, {
          href: `${USER_AREA_BASE_PATH}/${Routes.TEAMS}`,
          theme: "primary",
          icon: /*#__PURE__*/jsx(TeamsIcon, {
            height: "17"
          }),
          children: "Mine hold"
        }), /*#__PURE__*/jsx(CloseButton, {
          label: "Luk besked",
          onClose: () => props.onDismiss()
        })]
      })
    })
  });
}
const localStorageKey = "pm2:user-area/component-entries/welcome-notice.seen";
function useWelcomeNoticeState(userHasNoTeams) {
  const [active, actions] = useToggleState(() => !safeLocalStorage.getItem(localStorageKey));
  const onDismiss = useCallback(() => {
    safeLocalStorage.setItem(localStorageKey, "true");
    actions.disable();
  }, [actions]);

  // In case the current user never has had any teams, then there is no reason
  // for displaying the welcome notice, as they have not used the feature in
  // mit|gyldendal previously.
  useEffect(() => {
    if (userHasNoTeams) {
      onDismiss();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userHasNoTeams]);
  return {
    active: active && !userHasNoTeams,
    onDismiss
  };
}

export { WelcomeNotice, useWelcomeNoticeState };
//# sourceMappingURL=atom.welcome-notice.js.map
